var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "nav-icon-fill",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38 29c-4.967 0-9 4.033-9 9s4.033 9 9 9 9-4.033 9-9-4.033-9-9-9zm0 2c3.863 0 7 3.137 7 7s-3.137 7-7 7-7-3.137-7-7 3.137-7 7-7z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.085 38.715 2.121 2.121a1 1 0 0 0 1.414 0l4.242-4.242a1 1 0 0 0-1.414-1.414l-3.535 3.535-1.414-1.414a1 1 0 0 0-1.414 1.414zM20 8.968a5.001 5.001 0 0 0-3.525 1.454l-.011.011A5 5 0 0 0 15 13.968v2c0 1.326.527 2.598 1.464 3.536a5.004 5.004 0 0 0 7.072 0A5.004 5.004 0 0 0 25 15.968v-2a5 5 0 0 0-5-5zm0 2c-.793 0-1.553.314-2.115.872l-.006.007A3 3 0 0 0 17 13.968v2c0 .793.314 1.553.872 2.115l.007.007A3 3 0 0 0 23 15.968v-2a3 3 0 0 0-3-3zM29 28a5.004 5.004 0 0 0-1.464-3.536A5.004 5.004 0 0 0 24 23h-8a5.004 5.004 0 0 0-3.536 1.464A5.004 5.004 0 0 0 11 28a1 1 0 0 0 2 0c0-.796.316-1.559.879-2.121A2.996 2.996 0 0 1 16 25h8c.796 0 1.559.316 2.121.879.563.562.879 1.325.879 2.121a1 1 0 0 0 2 0z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.133 41.301a44.17 44.17 0 0 1-5.921 3.651.497.497 0 0 1-.415.005c-1.966-.995-7.652-4.139-11.89-9.09C5.151 32.647 3 28.653 3 23.968V16a1 1 0 0 0-2 0v7.968c0 5.189 2.335 9.633 5.388 13.2 4.468 5.22 10.46 8.54 12.509 9.575l.016.009a2.501 2.501 0 0 0 2.176-.002l.015-.007a46.114 46.114 0 0 0 6.209-3.828 1 1 0 0 0-1.18-1.614zM3 12V9.425a.5.5 0 0 1 .481-.499l.014-.001c5.056-.258 10.542-1.889 16.222-5.913a.494.494 0 0 1 .572-.001h.002c5.635 3.947 11.183 5.64 16.212 5.916l.016.001c.266.01.476.228.476.494v.002C37 13.366 37 23.968 37 23.968c0 .649-.041 1.285-.12 1.908a1.001 1.001 0 0 0 1.985.25c.088-.704.135-1.423.135-2.158 0 0 0-10.603-.005-14.547a2.495 2.495 0 0 0-2.384-2.491c-4.71-.259-9.897-1.862-15.173-5.557a2.495 2.495 0 0 0-2.877.007C13.248 5.144 8.123 6.686 3.393 6.928A2.5 2.5 0 0 0 1 9.424V12a1 1 0 0 0 2 0z",
    fill: "#000000",
    opacity: 1,
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/Auth.f4398cc94a23b05152794e975dd829ad.svg";
export { ForwardRef as ReactComponent };